// https://observablehq.com/@namitmohale/grouped-bar-chart@359
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Grouped Bar Chart

Compare to a [stacked bar chart](/@d3/stacked-bar-chart).`
)});
  main.variable(observer("chart")).define("chart", ["d3","DOM","width","height","titleText","titleSize","data","x0","groupKey","keys","x1","y","margin","color","tooltipSize","xAxis","yAxis","legend"], function(d3,DOM,width,height,titleText,titleSize,data,x0,groupKey,keys,x1,y,margin,color,tooltipSize,xAxis,yAxis,legend)
{
  const svg = d3.select(DOM.svg(width, height));
  
  svg.append('text')
     .attr('class', 'title')
     .text(titleText)
     .attr('y', 15)
      .attr('x', width/3)
     .attr('font-size', titleSize);

  var bars = svg.append("g")
    .selectAll("g")
    .data(data.dat);
  
  bars
    .join("g")
      .attr("transform", d => `translate(${x0(d[groupKey])},0)`)
    .selectAll("rect")
    .data(d => keys.map(key => ({key, value: d[key]})))
    .join("rect")
      .attr("x", d => x1(d.key))
      .attr("y", d => d.value ? y(d.value) : margin.top)
      .attr("width", x1.bandwidth())
      .attr("height", d => d.value ? y(0) - y(d.value) : height - margin.bottom - margin.top)
      .attr("fill", d => d.value ? color(d.key) : 'transparent')
    .on("mouseenter", function(d) {
        svg.append("text").attr("class", "tool")
          .attr("x", x0(d.path[1].__data__[groupKey]) + x1(d.path[0].__data__.key))
          // .attr("y", y(d.path[0].__data__.value)-25)
          .attr("y", margin.top - 50)
          .style("display", null)
          // .style("fill", color(d.path[0].__data__.key))
    .style("fill", 'black')
          .text("Catergory: " + d.path[0].__data__.key.charAt(0).toUpperCase() + d.path[0].__data__.key.slice(1))
          .attr('font-size', tooltipSize)
        svg.append("text").attr("class", "tool1")
          .attr("x", x0(d.path[1].__data__[groupKey]) + x1(d.path[0].__data__.key))
          // .attr("y", y(d.path[0].__data__.value)-10)
          .attr("y", margin.top - 35)
          .style("display", null)
          // .style("fill", color(d.path[0].__data__.key))
    .style("fill", 'black')
          .text("Average Budget: " + Number(d.path[0].__data__.value).toFixed(2))
          .attr('font-size', tooltipSize)
      })					
      .on("mouseout", function(d) {		
        svg.selectAll("text.tool").style("display", "none")
        svg.selectAll("text.tool1").style("display", "none")
      });

  svg.append("g")
  .attr("class", "x-axis")
      .call(xAxis);

  svg.append("g")
      .call(yAxis);

  svg.append("g")
      .call(legend);
  
  svg.node().scrollBy(5, 0);

  return svg.node();
}
);
  main.variable(observer("zoom")).define("zoom", ["margin","width","height","d3","x0","data","groupKey","keys","x1","xAxis"], function(margin,width,height,d3,x0,data,groupKey,keys,x1,xAxis){return(
function zoom(svg) {
  const extent = [[margin.left, margin.top], [width - margin.right, height - margin.top]];

  svg.call(d3.zoom()
      .scaleExtent([1, 8])
      .translateExtent(extent)
      .extent(extent)
      .on("zoom", zoomed));

  function zoomed(event) {
    x0.range([margin.left, width - margin.right].map(d => event.transform.applyX(d)));
    svg.selectAll("rect").data(data.dat)
      .attr("x", d => x0(d[groupKey])).attr("width", x0.bandwidth())
    // .attr("transform", d => `translate(${x0(d[groupKey])},0)`)
    .data(d => keys.map(key => ({key, value: d[key]}))).selectAll("rect")
    .attr("x", d => x1(d.key)).attr("width", x1.bandwidth());
    svg.selectAll(".x-axis").call(xAxis);
  }
}
)});
  main.variable(observer("wrap")).define("wrap", ["d3"], function(d3){return(
(text) => {
        const width=50
        text.each(function() {
          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          while (words.length >0) {
              word=words.pop()
            line.push(word);
            tspan.text(line.join(" "));
            // if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y-10).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            // }
          }
        });
      }
)});
  main.variable(observer("legend")).define("legend", ["width","legendDistanceFromRight","margin","legendTextSize","color"], function(width,legendDistanceFromRight,margin,legendTextSize,color){return(
svg => {
  const g = svg
      .attr("transform", `translate(${width-legendDistanceFromRight},${margin.top})`)
      .attr("text-anchor", "end")
      .attr("font-family", "sans-serif")
      .attr("font-size", legendTextSize)
    .selectAll("g")
    .data(color.domain().slice().reverse())
    .join("g")
      .attr("transform", (d, i) => `translate(0,${i * 20})`);

  g.append("rect")
      .attr("x", -19)
      .attr("width", 19)
      .attr("height", 19)
      .attr("fill", color);

  g.append("text")
      .attr("x", -24)
      .attr("y", 9.5)
      .attr("dy", "0.35em")
      .text(d => d);
}
)});
  main.variable(observer("x0")).define("x0", ["d3","data","groupKey","margin","width"], function(d3,data,groupKey,margin,width){return(
d3.scaleBand()
    .domain(data.dat.map(d => d[groupKey]))
    .rangeRound([margin.left, width - margin.right])
    .paddingInner(0.15)
)});
  main.variable(observer("x1")).define("x1", ["d3","keys","x0"], function(d3,keys,x0){return(
d3.scaleBand()
    .domain(keys)
    .rangeRound([0, x0.bandwidth()])
    .padding(0.05)
)});
  main.variable(observer("y")).define("y", ["d3","data","keys","height","margin"], function(d3,data,keys,height,margin){return(
d3.scaleLinear()
    .domain([0, d3.max(data.dat, d => d3.max(keys, key => d[key]))]).nice()
    .rangeRound([height - margin.bottom, margin.top])
)});
  main.variable(observer("legendDistanceFromRight")).define("legendDistanceFromRight", function(){return(
20
)});
  main.variable(observer("color")).define("color", ["d3","colorType","keys"], function(d3,colorType,keys){return(
d3.scaleOrdinal(d3.quantize(colorType, keys.length))
)});
  main.variable(observer("colorType")).define("colorType", ["d3"], function(d3){return(
d3.interpolateCividis
)});
  main.variable(observer("xAxis")).define("xAxis", ["height","margin","d3","x0","xAxisFontSize","wrap"], function(height,margin,d3,x0,xAxisFontSize,wrap){return(
g => g
    .attr("transform", `translate(0,${height - margin.bottom})`)
    .call(d3.axisBottom(x0).tickSizeOuter(0))
    .attr("font-size", xAxisFontSize)
    .selectAll("text").call(wrap, x0.bandwidth())
    .call(g => g.select(".domain").remove())
)});
  main.variable(observer("yAxis")).define("yAxis", ["margin","d3","y","data"], function(margin,d3,y,data){return(
g => g
    .attr("transform", `translate(${margin.left},0)`)
    .call(d3.axisLeft(y).ticks(null, "s"))
    .call(g => g.select(".domain").remove())
    .call(g => g.select(".tick:last-of-type text").clone()
        .attr("x", -10)
          .attr("y", -20)
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
        .text(data.y))
)});
  main.variable(observer("data")).define("data", ["yAxisText"], function(yAxisText){return(
{
    "dat":
      [
        {
          Team: "Product Management",
          Lifestyle: 10,
          Popular: 15,
          Travel: 11,
          Commute: 9,
          Wellness: 7
        },
        {
          Team: "Data",
          Lifestyle: 10,
          Popular: 13,
          Travel: 8,
          Commute: 6,
          Wellness: 0
        },
        {
          Team: "Development",
          Lifestyle: 10,
          Popular: 11,
          Travel: 8,
          Commute: 5,
          Wellness: 5
        },
        {
          Team: "Human Resources",
          Lifestyle: 9,
          Popular: 8,
          Travel: 5,
          Commute: 7,
          Wellness: 2
        },
        {
          Team: "Marketing",
          Lifestyle: 3,
          Popular: 6,
          Travel: 4,
          Commute: 6,
          Wellness: 3
        },
        {
          Team: "Sales",
          Lifestyle: 10,
          Popular: 15,
          Travel: 11,
          Commute: 9,
          Wellness: 7
        },
        {
          Team: "Misc",
          Lifestyle: 10,
          Popular: 13,
          Travel: 8,
          Commute: 6,
          Wellness: 0
        },
        {
          Team: "DevOps",
          Lifestyle: 10,
          Popular: 11,
          Travel: 8,
          Commute: 5,
          Wellness: 5
        },
        {
          Team: "C Levels",
          Lifestyle: 9,
          Popular: 8,
          Travel: 5,
          Commute: 7,
          Wellness: 2
        },
        {
          Team: "Team Leads",
          Lifestyle: 3,
          Popular: 6,
          Travel: 4,
          Commute: 6,
          Wellness: 3
        }
      ],
    "columns": ["Team", "Lifestyle", "Popular", "Travel", "Commute", "Wellness"],
    "y": yAxisText
  }
)});
  main.variable(observer("groupKey")).define("groupKey", ["data"], function(data){return(
data.columns[0]
)});
  main.variable(observer("keys")).define("keys", ["data"], function(data){return(
data.columns.slice(1)
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 90, right: 120, bottom: 50, left: 40}
)});
  main.variable(observer("xAxisFontSize")).define("xAxisFontSize", function(){return(
13
)});
  main.variable(observer("titleSize")).define("titleSize", function(){return(
20
)});
  main.variable(observer("legendTextSize")).define("legendTextSize", function(){return(
12
)});
  main.variable(observer("tooltipSize")).define("tooltipSize", function(){return(
12
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"Budget per Team per Category"
)});
  main.variable(observer("yAxisText")).define("yAxisText", function(){return(
"Average Budget"
)});
  main.variable(observer("height")).define("height", function(){return(
450
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  return main;
}
